import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { usePermissions } from '../modules/auth/hooks/usePermissions'

/**
 * Decides where to send the user after login (or when they navigate
 * to "/"). Dashboard is the right home for most people, but a pure
 * fabricante user — no role anywhere, only manufacturer_users entries
 * — gets stuck on a 404 / empty dashboard because the page queries by
 * last_company_id, which they don't have.
 *
 * Resolution order:
 *   1. is_manufacturer && !is_admin_anywhere → /manufacturer/stock
 *   2. anyone else → /dashboard
 *
 * usePermissions is still loading on first paint (cached on disk if
 * the session was active before, otherwise empty defaults). Empty
 * defaults send everyone to /dashboard, which is fine — the moment
 * permissions land, the manufacturer page check on the dashboard
 * route falls back to its own gating.
 */
export const DefaultLanding: FC = () => {
  const perms = usePermissions()

  if (perms.isLoading) {
    // Render nothing while we wait for /me/permissions. Same overall
    // flash as if there's no router transition at all.
    return null
  }

  const onlyManufacturer = perms.is_manufacturer && !perms.is_admin_anywhere
  return <Navigate to={onlyManufacturer ? '/manufacturer/stock' : '/dashboard'} replace />
}
